<h2 mat-dialog-title class="text-lg font-bold mb-1">Horario(s) de Entrega</h2>
<mat-dialog-content class="modal-content">
  <form [formGroup]="formData" class="grid grid-cols-1 gap-4">
    <mat-form-field appearance="fill" class="col-span-1">
      <mat-label>Fecha de Inicio</mat-label>
      <input
        matInput
        [matDatepicker]="pickerStart"
        formControlName="datetimeStart"
        name="datetimeStart"
        required
      />
      <mat-datepicker-toggle
        matSuffix
        [for]="pickerStart"
      ></mat-datepicker-toggle>
      <mat-datepicker #pickerStart></mat-datepicker>
    </mat-form-field>

    <mat-form-field appearance="fill" class="col-span-1">
      <mat-label>Fecha de Fin</mat-label>
      <input
        matInput
        [matDatepicker]="pickerEnd"
        formControlName="datetimeEnd"
        name="dateEnd"
        required
      />
      <mat-datepicker-toggle
        matSuffix
        [for]="pickerEnd"
      ></mat-datepicker-toggle>
      <mat-datepicker #pickerEnd></mat-datepicker>
    </mat-form-field>
  </form>
</mat-dialog-content>
<mat-dialog-actions class="modal-actions flex justify-end">
  <button mat-button mat-dialog-close class="align-left">Cancelar</button>
  <button
    mat-raised-button
    color="primary"
    (click)="save()"
    [disabled]="!formData.valid"
    class="justify-end"
  >
    {{ "Guardar" }}
  </button>
</mat-dialog-actions>
